import React from 'react'
import { AlertTriangle, Info } from 'lucide-react'

import { nutrimaticLabels } from '@/nutrimatic'
import { cn } from '@/lib/utils'
import { HitchhikersMark } from '@/wallet/HitchhikersMark'

export type NutrimaticMobileNoticeVariant = 'info' | 'warning' | 'blocked'

const VARIANT_ICON: Record<Exclude<NutrimaticMobileNoticeVariant, 'blocked'>, React.ElementType> = {
  info: Info,
  warning: AlertTriangle,
}

/** Aviso editorial Nutri-Matic móvil — info, advertencia o pausa de mercado. */
export function NutrimaticMobileNotice({
  variant = 'info',
  title,
  description,
  className,
}: {
  variant?: NutrimaticMobileNoticeVariant
  title: string
  description?: string
  className?: string
}) {
  if (variant === 'blocked') {
    return (
      <aside
        className={cn('nm-mobile-simple__notice', 'nm-mobile-simple__notice--blocked', className)}
        role="status"
      >
        <div className="nm-mobile-simple__notice-panel">
          <span className="nm-mobile-simple__notice-accent" aria-hidden />
          <p className="nm-mobile-simple__notice-kicker">
            <HitchhikersMark className="nm-mobile-simple__notice-kicker-mark" />
            <span>{nutrimaticLabels.edition}</span>
          </p>
          <p className="nm-mobile-simple__notice-title">{title}</p>
          {description ? <p className="nm-mobile-simple__notice-desc">{description}</p> : null}
        </div>
      </aside>
    )
  }

  const Icon = VARIANT_ICON[variant]

  return (
    <div
      className={cn(
        'nm-mobile-simple__notice',
        variant === 'info' && 'nm-mobile-simple__notice--info',
        variant === 'warning' && 'nm-mobile-simple__notice--warning',
        className,
      )}
      role="status"
    >
      <div className="nm-mobile-simple__notice-panel nm-mobile-simple__notice-panel--compact">
        <span className="nm-mobile-simple__notice-accent" aria-hidden />
        <span className="nm-mobile-simple__notice-icon" aria-hidden>
          <Icon className="size-3.5" strokeWidth={2.25} />
        </span>
        <div className="nm-mobile-simple__notice-copy">
          <p className="nm-mobile-simple__notice-title">{title}</p>
          {description ? <p className="nm-mobile-simple__notice-desc">{description}</p> : null}
        </div>
      </div>
    </div>
  )
}
